<div id="module-cards-list" [@animateStagger]="{ value: '50' }" [class.fixed-width-tiles]="fixedWidthTiles">
    <span id="ruler" class="ruler"></span>
    <!--
      Always pass a string to fxLayout — Flex Layout calls .split() on the value.
      fixed-width-tiles CSS uses display:grid !important and overrides this flex layout.
    -->
    <div class="modules-card-container" fxLayout="row wrap" fxLayoutAlign="start">
        <div
            class="module-card image-module-card"
            [class.p-4]="!fixedWidthTiles"
            *ngFor="let module of myModule$ | async"
            [@animate]="{ value: '*', params: { y: '100%' } }"
        >
            <app-modules-card
                (clickedTag)="tagMultiSelectService.tagSelected($event, 'myModulesSelectedTags')"
                (clickedPinModule)="onPinModule($event)"
                [module]="module"
                [finalGrade]="finalGrades[module.id]"
                [myModuleUser]="myModuleUser[module.id]"
                [profile]="profile"
                [isCertificateOfAttendanceFeatureEnabled]="isCertificateOfAttendanceFeatureEnabled"
                [isPinned]="isPinned"
                [showPinModule]="showPinModule"
                [isTeamMembersPage]="isTeamMembersPage"
            ></app-modules-card>
        </div>
    </div>
</div>
